import "@storoey/sui/dist/sui.css";
import { createRouter, RouterProvider } from "@tanstack/solid-router";
import "solid-devtools";
import { ErrorBoundary } from "solid-js";
import { render } from "solid-js/web";
import { routeTree } from "./routeTree.gen";

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultStaleTime: 5000,
  scrollRestoration: true,
});

// Register things for typesafety
declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("app")!;

if (!rootElement.innerHTML) {
  render(
    () => (
      <>
        <ErrorBoundary
          fallback={(error) => (
            <div style={{ padding: "16px" }}>
              <h1>App error</h1>
              <pre style={{ "white-space": "pre-wrap" }}>{String(error)}</pre>
            </div>
          )}
        >
          <RouterProvider router={router} />
        </ErrorBoundary>
      </>
    ),
    rootElement
  );
}
